'use client'

import { Loader } from '@/components/atoms'
import { AppRoutes } from '@/routes'
import { usePathname } from 'next/navigation'
import { ReactNode, useEffect, useState } from 'react'
import { ZendeskProvider } from 'react-use-zendesk'

function ZenProvider({ children }: {
  children: ReactNode;
}) {
  return <ZendeskProvider apiKey={process.env.NEXT_PUBLIC_ZENDESK_API_KEY}>{children}</ZendeskProvider>
}

export function AuthProvider({ children }: {
  children: ReactNode;
}) {
  const [hasMounted, setHasMounted] = useState(false)
  const pathname = usePathname()

  useEffect(() => setHasMounted(true), [])

  if (hasMounted && pathname === AppRoutes.AUTH_SIGNIN) return <ZenProvider>{children}</ZenProvider>

  if (!hasMounted && !pathname.includes('captcha')) return <Loader />

  return <ZenProvider>{children}</ZenProvider>
}
